import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./BackToTop";
import { Styles } from "./styles/footer.js";
import Swiper from "react-id-swiper";
import { Link } from "react-router-dom";

function FooterTwo() {
  const data = [
    { Id: "1", Image: "NewArrival.jpeg" },
    { Id: "2", Image: "NewArrival1.jpg" },
    { Id: "3", Image: "NewArrival2.jpg" },
    { Id: "4", Image: "NewArrival3.jpg" },
    { Id: "5", Image: "NewArrival4.jpg" },
  ];

  const params = {
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
  };

  return (
    <Styles>
      {/* Footer Two */}
      <footer
        className="footer2"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/footer-bg.jpg)`,
        }}
      >
        <Container>
          <Row>
            <Col md="5">
              <div className="f-newsletter">
                <div className="box-content">
                  <h5>Contact Us</h5>
                  <p>
                    Librarian,
                    <br />
                    Library and Information Center
                    <br />
                    Bangalore Institute of Technology
                    <br />
                    K R Road, V V Pura, Bangalore, Karnataka, India.
                    <br />
                    Pincode - 560004
                    <br />
                  </p>
                  <p>
                    <a
                      href="mailto:bitlibrary@bit-bangalore.edu.in"
                      style={{ color: "white" }}
                    >
                      bitlibrary@bit-bangalore.edu.in
                    </a>
                    <br />
                    <a
                      href="mailto:bitlibrary79@rediffmail.com"
                      style={{ color: "white" }}
                    >
                      bitlibrary79@rediffmail.com
                    </a>
                    <br />
                    <a
                      href="mailto:bitlibrary79@gmail.com"
                      style={{ color: "white" }}
                    >
                      bitlibrary79@gmail.com
                    </a>
                  </p>
                  <p>+91 7795323103</p>
                </div>
              </div>
            </Col>
            <Col md="4">
              <div className="f-links">
                <h5>Quick Links</h5>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="https://access.vtuconsortium.com/bit"
                      target="_blank"
                    >
                      <i className="las la-angle-right"></i>MAPMy Access
                    </a>
                  </li>
                  <li>
                    <a href="http://119.161.98.143/localguru/" target="_blank">
                      <i className="las la-angle-right"></i>NPTEL
                    </a>
                  </li>
                  <li>
                    <a href="https://ndl.iitkgp.ac.in/" target="_blank">
                      <i className="las la-angle-right"></i>NDLI
                    </a>
                  </li>
                  <li>
                    <a href="http://119.161.98.143:8082/" target="_blank">
                      <i className="las la-angle-right"></i>WEB OPAC
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://drive.google.com/drive/folders/1U5oJPB7DF36FZD6hRudUad8g2t-e7lop?usp=sharing"
                      target="_blank"
                    >
                      <i className="las la-angle-right"></i>VTU Question Papers
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://drive.google.com/drive/folders/1Cs_RcD6sIuYPuY5MJ4nYkA34XJfOjipD"
                      target="_blank"
                    >
                      <i className="las la-angle-right"></i>Project Reports List
                    </a>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/library-gallery"}>
                      <i className="las la-angle-right"></i>Gallery
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="3" style={{ textAlign: "center" }}>
              <div className="f-links">
                <h5>New Arrivals</h5>
                <Swiper getSwiper={null} className="trancarousel" {...params}>
                  {data.map((item, i) => (
                    <div
                      key={i}
                      className="single_post widgets_small post_type5"
                    >
                      <img
                        className="img-fluid"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/general/" +
                          item.Image
                        }
                        alt="single-img-eighteen"
                      />
                    </div>
                  ))}
                </Swiper>

                <form id="form4" className="form paddingtop-2">
                  <a
                    href="https://drive.google.com/drive/folders/1AEukXi0eSGvD3pvC6PgYEbGMZ1eg0IYu?usp=sharing"
                    target="_blank"
                    style={{ color: "white" }}
                  >
                    View Book List
                  </a>
                </form>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Back To Top  */}
        <BackToTop />
      </footer>
    </Styles>
  );
}

export default FooterTwo;
